module.exports = __webpack_public_path__ + "img/bi.58a71c78.png";